import type {
  postTestimonialsCreateResponse,
  postTestimonialsLinkResponse,
  TestimonialsRatingValue,
} from '@lt/api/dist/methods/testimonials/types';
import type { Dispatch, SetStateAction } from 'react';
import type { AxiosError } from 'axios';

export type TestimonialsFormValues = {
  title: string;
  content: string;
  order_id?: string;
  tour_selection: TestimonialsRatingValue | undefined;
  booking_simplicity: TestimonialsRatingValue | undefined;
  usability: TestimonialsRatingValue | undefined;
};

export enum TestimonialsFormTypes {
  init,
  create,
  auth,
  loading,
  done,
}

export type SetFormTypes = Dispatch<SetStateAction<TestimonialsFormTypes>>;
export type SetTestimonials = Dispatch<
  SetStateAction<postTestimonialsCreateResponse | undefined>
>;

export type HandleLinkClientToTestimonials = (
  testimonialsId: number,
  clientId: number,
) => Promise<postTestimonialsLinkResponse | AxiosError>;
